import type { ComponentType } from 'react';

import { VButton, VFlex } from '@/package';

type EmptyRowProps = {
  Icon: ComponentType<{ className?: string }>;
  description: string;
  buttonText: string;
  ButtonIcon: ComponentType<{ className?: string }>;
  onClick: () => void;
};

const EmptyRow = ({
  Icon,
  description,
  buttonText,
  ButtonIcon,
  onClick,
}: EmptyRowProps) => {
  return (
    <VFlex className="w-full pt-[160px]" justify="center">
      <VFlex className="w-[394px] flex-col items-center gap-4">
        <VFlex direction="col" className="items-center gap-2 text-blue-300">
          <Icon className="size-[66px]" />
          <div className="text-center text-body-xl whitespace-pre-line">
            {description}
          </div>
        </VFlex>

        <VButton size="lg" onClick={onClick}>
          <ButtonIcon />
          {buttonText}
        </VButton>
      </VFlex>
    </VFlex>
  );
};

export default EmptyRow;
